import { PocIcon } from 'commons/components/components-wrapper/poc-icon.component';
import { PocListItem } from 'commons/components/components-wrapper/poc-list-item.component';
import { useTranslation } from 'core/i18n';

export interface CustomAlarmDeleteCommandComponentProps {
    onClick: VoidFunction;
}

export const CustomAlarmDeleteCommandComponent: React.FC<CustomAlarmDeleteCommandComponentProps> = ({ onClick }) => {
    const { t } = useTranslation();

    return (
        <PocListItem data-testid="custom-alarm-delete-command" onClick={onClick}>
            <PocIcon slot="prefix" name="delete" family="outlined" />
            {t('settings.devices.custom-alarms.actions.delete')}
        </PocListItem>
    );
};
